import { create } from "zustand";

export const useQuizStore = create((set) => ({
  data: null,
  removeData: () => set({ data: null }),
  setData: (data) => set({ data: data }),
}));

